// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"852c38767d130f460520","133":"f0071f54456841400bfc","134":"a96c677694601e2c3565","181":"716bd505c6087d93bed2"}[chunkId] + ".chunk.js";
};